module.exports = __webpack_public_path__ + "static/img/23.a114c6c1.png";